import { getCategoryKey, getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const fireGeneralScreenEvent = (webUrl, title, parent) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    title: title,
    screen_id: getCategoryKey(webUrl),
    parent: parent,
  });
};
export const fireClickedEvent = (webUrl, title, l2Categorty) => {
  fireEvent({
    category: 'clicked_subtab_in_general_screen',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    title: title,
    screen_id: getCategoryKey(webUrl),
    display_type: l2Categorty ? 'horizontal' : 'vertical',
  });
};
export const fireExpandedEvent = (item, level) => {
  fireEvent({
    category: 'expanded_category_navigation_item',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    item_level: level,
    item_type: 'parent',
    parent: item.tabName,
    item_name: item.tabName,
  });
};
export const fireCategoryClickHandler = (item, level, itemType) => {
  fireEvent({
    category: 'clicked_category_navigation_item',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    item_level: level,
    item_type: itemType,
    parent: item.tabName,
    item_name: item.tabName,
  });
};

export const fireViewAllProductsEvent = (
  btnCta,
  sectionName,
  category_name,
) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    parent: 'Show All',
    shape: 'Show All',
    cta: btnCta,
    section_name: sectionName,
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    category_name: category_name,
  });
};
